import React, { useState, useEffect, useRef } from 'react';
import styled from 'astroturf/react';
import _Container from "TypeWriter-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/TypeWriter.tsx?styleId=Container";
import _PresetHeightContainer from "TypeWriter-PresetHeightContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/TypeWriter.tsx?styleId=PresetHeightContainer";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const PresetHeightContainer = /*#__PURE__*/styled("div", null, {
  displayName: "PresetHeightContainer",
  styles: _PresetHeightContainer
});

type TypeWriterProps = {
  /** The text content to be displayed with the typewriter effect */
  text: string;
  /** The speed of the typewriter effect in milliseconds per word. Defaults to 30ms */
  speed?: number;
  /** Whether to preset the container height to match the full text height */
  presetHeight?: boolean;
  /** Optional callback function that fires when the typewriter effect completes */
  onComplete?: () => void;
};

export const TypeWriter: React.FC<TypeWriterProps> = ({
  text,
  speed = 50,
  presetHeight = false,
  onComplete = () => null,
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const hiddenTextRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!text) return;

    const words = text.split(' ');

    if (currentIndex >= words.length) {
      onComplete();
      return;
    }

    // Add extra delay for words with punctuation
    const currentWord = words[currentIndex];
    const hasPunctuation = /[.,!?;:]/.test(currentWord);
    const delay = hasPunctuation ? speed * 6 : speed;

    const timer = setTimeout(() => {
      setDisplayedText(
        (prev) => prev + (currentIndex === 0 ? '' : ' ') + words[currentIndex],
      );
      setCurrentIndex((prev) => prev + 1);
    }, delay);

    return () => clearTimeout(timer);
  }, [currentIndex, text, speed, onComplete]);

  // Reset state when text changes
  useEffect(() => {
    setDisplayedText('');
    setCurrentIndex(0);
  }, [text]);

  return (
    <Container>
      <div
        style={{
          height: presetHeight ? hiddenTextRef.current?.offsetHeight : 'auto',
        }}
      >
        {displayedText}
      </div>
      {presetHeight && (
        <PresetHeightContainer ref={hiddenTextRef}>
          {text}
        </PresetHeightContainer>
      )}
    </Container>
  );
};
